import { render, staticRenderFns } from "./TriangleTemplate.vue?vue&type=template&id=297feb16&scoped=true&"
import script from "./TriangleTemplate.vue?vue&type=script&lang=js&"
export * from "./TriangleTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297feb16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('297feb16')) {
      api.createRecord('297feb16', component.options)
    } else {
      api.reload('297feb16', component.options)
    }
    module.hot.accept("./TriangleTemplate.vue?vue&type=template&id=297feb16&scoped=true&", function () {
      api.rerender('297feb16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/TriangleTemplate.vue"
export default component.exports